import { useEffect, useState } from 'react';
import { fetchTrialState } from 'purchase-motions-api/query/trials';

// This is a map of trial products that conflict with each other.
// If the user has a trial of one of these products, they cannot activate a trial of the other.
// For example, if the user has a trial of MARKETING_PLUS_ENTERPRISE, they cannot activate a trial of CMS_ENTERPRISE or MARKETING_ENTERPRISE.
const conflictingTrialsMap = {
  ['marketing-plus-enterprise-bundle']: ['marketing-hub-enterprise', 'cms-hub-enterprise'],
  ['marketing-plus-professional-bundle']: ['marketing-hub-professional', 'cms-hub-professional'],
  ['marketing-hub-professional']: ['marketing-plus-professional-bundle'],
  ['marketing-hub-enterprise']: ['marketing-plus-enterprise-bundle'],
  ['cms-hub-professional']: ['marketing-plus-professional-bundle'],
  ['cms-hub-enterprise']: ['marketing-plus-enterprise-bundle']
};
export const useTrialState = apiName => {
  var _data$activeTrials, _data$expiredTrials;
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [data, setData] = useState();
  useEffect(() => {
    fetchTrialState().then(response => {
      setData(response);
      setLoading(false);
    }).catch(e => {
      setError(e);
      setLoading(false);
    });
  }, []);
  const activeTrials = (_data$activeTrials = data === null || data === void 0 ? void 0 : data.activeTrials) !== null && _data$activeTrials !== void 0 ? _data$activeTrials : new Set();
  const expiredTrials = (_data$expiredTrials = data === null || data === void 0 ? void 0 : data.expiredTrials) !== null && _data$expiredTrials !== void 0 ? _data$expiredTrials : new Set();
  const conflictingTrials = [...activeTrials].filter(trial => {
    var _conflictingTrialsMap;
    return trial === apiName || ((_conflictingTrialsMap = conflictingTrialsMap[trial]) === null || _conflictingTrialsMap === void 0 ? void 0 : _conflictingTrialsMap.includes(apiName));
  });
  return {
    loading,
    error,
    trialState: {
      activeTrials,
      expiredTrials,
      conflictingTrials
    }
  };
};